module.exports = __webpack_public_path__ + "static/ubs-8edf1988ac4644774e3813e139d48554.svg";